// src/components/EvaluationSteps.tsx
import type { EvaluationStep } from '../types';

export function EvaluationSteps({ evaluation }: { evaluation: { steps: EvaluationStep[] } }) {
  if (!evaluation?.steps?.length) return null;

  return (
    <div className="bg-white/10 p-6 rounded-xl shadow text-yellow-100">
      <h3 className="text-2xl font-bold mb-4 text-yellow-400">📊 Evaluation Phases</h3>
      <div className="space-y-4">
        {evaluation.steps.map((step, i) => (
          <div
            key={i}
            className="bg-black/20 rounded-lg p-4 border border-white/10"
          >
            <div className="flex items-center gap-3 mb-2">
              <div className="bg-yellow-400 text-black text-sm font-bold px-3 py-1 rounded-full">
                Phase {i + 1}
              </div>
              <h4 className="text-lg font-semibold text-yellow-200">
                {step.title}
              </h4>
            </div>
            <p className="text-yellow-100">{step.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
